// 为了和功能组件库的路径一致，做了这个转包。
import Fuzzy, { FuzzyProps as _FuzzyProps } from '@/common/components/Form/Fuzzy/Fuzzy';

export interface FuzzyProps extends _FuzzyProps {};
export default Fuzzy;
